<template>
    
    <!-- <Test v-model="inputVal" /> -->
    <div class="page-container">
        <div class="page-wrapper" :style=" { height:'560px', backgroundImage:`url(${bgImg})` }">
            <div class="page-content">
                <div class="text-container">
                    <div class="text">华翊产品</div>
                    <div class="sub-text" style="margin:36px 0;">应用、算法、服务、硬件 独立交付、灵活配置</div>
                    <el-button size="large" class="custom-btn-blue"  @click="handleGo">立即试用</el-button>
                </div>
            </div>
        </div>
        <div class="page-wrapper" style="height:auto; background:#F5F7FA;">
            <div class="page-content" style="padding:50px 0;">
                <div style="margin-bottom:50px; text-align:center;">
                    <div class="custom-radio">
                        <div 
                            v-for="item in menuData"
                            :key="item.key"
                            :class="{ 'custom-radio-item':true, 'selected':item.key === menuKey  }"
                            @click=" menuKey = item.key "
                        >
                            {{  item.label }}
                        </div>
                    </div>
                </div>
                <div class="list-container">
                    <div class="list-title"></div>
                    <div class="list-content">
                        <div v-if=" menuKey === 'hardware' ">  
                            <div
                                v-for="item in list"
                                class="card-2"
                                @click="$router.push(`/product-detail?type=hardware&id=${item.id}`)"
                                style="cursor:pointer;"
                            >
                                <div class="card-2-avatar" :style="{ backgroundImage:`url(${getFullPathMethod( item.productImgs ? item.productImgs.split(',')[0] : '' )})`}"></div>
                                <div class="card-2-content">
                                    <div class="card-2-title">{{ item.productShortTitle }}</div>
                                    <div class="card-2-text">{{  item.productTitle }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div
                                v-for="item in list"
                                :key="item.appCode"
                                class="card"
                                @click="handleRoute(item[dynamicKey])"
                                :style="{ cursor:menuKey === 'algorithm' ? 'auto' : 'pointer' }"
                            >
                                <div class="card-title">
                                    <div class="card-avatar"><img :src="menuKey === 'algorithm' ? item[menuKey + 'Icon'] : getFullPathMethod( item[menuKey + 'Icon'])" /></div>
                                    <div class="card-text">{{  item[menuKey + 'Name'] }}</div>
                                    <div style="margin-left:auto; "><i class="ri-arrow-right-line" style="color:#99a0ae; font-size:24px;"></i></div>
                                </div>
                                <el-tooltip class="custom-tooltip" v-if="menuKey === 'algorithm'" effect="light">
                                    <div slot="content" style="width:400px;">{{  item[menuKey + 'Intro'] }}</div>
                                    <div slot class="card-content">{{  item[menuKey + 'Intro'] || '还没有填写~' }}</div>
                                </el-tooltip>
                                <div v-else class="card-content">{{  item[menuKey + 'Intro'] || '还没有填写~' }}</div>
                                <div class="card-footer">
                                    <div 
                                        v-for="item in getTagList( menuKey === 'app' ? item.appType2 : item.serviceType )"    
                                        class="tag"
                                        :key="item"
                                    >{{ item }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination
                    v-if="total > pageInfo.pageSize"
                    class="custom-pagination"
                    :current-page="pageInfo.currentPage" 
                    :page-size="pageInfo.pageSize"
                    :total="total"
                    @current-change="handlePage"
                    background 
                    layout="prev,pager,next" 
                />
            </div>
        </div>
    </div>
</template>
<script>      
    import { getFullPath, getAppList, getServiceList, getEquipmentList } from '@/api/global.js';
    import bgImg from '@/assets/product-bg.jpg';
    import { json } from './algorithm.js';
    const menuData = [
        { label:'应用', key:'app' },
        { label:'服务', key:'service' },
        { label:'AI Agent', key:'algorithm'},
        { label:'硬件', key:'hardware' }
    ];
    export default {
        data(){
            return {
                inputVal:'222',
                bgImg,
                pageInfo:{ currentPage:1, pageSize:16 },
                total:0,
                list:[],
                allList:[],
                menuData,
                menuKey:'app'
            }
        },
        computed:{
            dynamicKey:function(){
                return this.menuKey === 'app' ? 'id' : this.menuKey === 'service' ? 'serviceCode' : 'id';
            }
        },
        methods:{
            getFullPathMethod(url){
                return getFullPath(url);
            },
            handleGo(){
                window.open('http://iot.ifmcs.com', '__blank');
            },
            getTagList(str){
                if ( !str ) return [];
                return str.split(',').slice(0, 2);
            },
            handleRoute(id){
                if ( this.menuKey === 'algorithm' ) return;
                this.$router.push(`/product-detail?type=${this.menuKey}&id=${id}`)
            },
            fetchAppList(){
                getAppList({ page:this.pageInfo.currentPage, pageSize:999 })
                .then(res=>{
                    if ( res.data.code === 200 ){
                        const arr = res.data.data.filter(i=>i.auditStatus === 3 && i.loginStatus !== 0 );
                        this.list = arr.slice(0, this.pageInfo.pageSize);
                        this.allList = arr;
                        this.total = arr.length;
                    }
                })
            },
            fetchServiceList(){
                getServiceList({ page:this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize, enable:false })
                .then(res=>{
                    if ( res.data.code === 200 ){
                        this.list = res.data.data.filter(i=>i.auditStatus === 3 );
                        this.total = res.data.total;
                    }
                })
            },
            fetchEquipmentList(){
                getEquipmentList({ page:this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize })
                .then(res=>{
                    if ( res.data.code === 200 ){
                        this.list = ( res.data.data.energyEquipmentMallEntities || [] ).filter(i=>i.auditStatus === 3 ) ;
                        this.total = res.data.total;
                    }
                })
            },
            fetchList(){
                if ( this.menuKey === 'app') {
                    this.fetchAppList();
                } else if ( this.menuKey === 'service' ) {
                    this.fetchServiceList();
                } else if ( this.menuKey === 'hardware') {
                    this.fetchEquipmentList();
                } else if ( this.menuKey === 'algorithm') {
                    this.list = json;
                }
            },
            handlePage(page){
                this.pageInfo = { ...this.pageInfo, currentPage:page };
            }
        },
        watch:{
            menuKey(newVal, oldVal){
                this.pageInfo = { ...this.pageInfo, currentPage:1 };
            },
            pageInfo(newVal, oldVal){
                if ( this.menuKey === 'app' ) {
                    const startIndex = ( this.pageInfo.currentPage - 1 ) * this.pageInfo.pageSize;
                    this.list = this.allList.slice( startIndex, startIndex + this.pageInfo.pageSize );
                } else {
                    this.fetchList();
                }
               
            }
        },
        mounted(){
            // function Promise2(fn){ 
            //     let state = 'pending';
            //     let value = null;
            //     const callbacks = [];
            //     this.then = function (onFulfilled){
            //         console.log('then...');
            //         console.log(onFulfilled);
            //         return new Promise2((resolve, reject)=>{
            //             handle({ //桥梁，将新 Promise 的 resolve 方法，放到前一个 promise 的回调对象中
            //                 onFulfilled, 
            //                 resolve
            //             })
            //         })
            //     }
            
            //     function handle(callback){
                 
            //         if(state === 'pending'){
            //             console.log('a')
            //             callbacks.push(callback)
            //             return;
            //         }

            //         if(state === 'fulfilled'){
            //             console.log('b');
            //             if(!callback.onFulfilled){
            //                 console.log('simple value...', value);
            //                 callback.resolve(value)
            //                 return;
            //             }
            //             console.log('value...', value);
            //             const ret = callback.onFulfilled(value) //处理回调
            //             callback.resolve(ret) //处理下一个 promise 的resolve
            //         }
            //     }
            //     function resolve(newValue){
            //         const fn = ()=>{
            //             if(state !== 'pending')return
                    
            //             state = 'fulfilled';
            //             value = newValue
            //             handelCb()
            //         }
                    
            //         setTimeout(fn,0) //基于 PromiseA+ 规范
            //     }

            //     function handelCb(){
            //         console.log('call length...', callbacks.length);
            //         while(callbacks.length) {
            //             const fulfiledFn = callbacks.shift();
            //             handle(fulfiledFn);
            //             if ( fulfiledFn.hasResult ) {
            //                 console.log(fulfiledFn.hasResult);
                            
            //             }
            //         };
            //     }

            //     fn(resolve)
            // }
            // new Promise2((resolve, reject)=>{
            //     setTimeout(()=>{
            //         resolve()
            //     }, 2000)
            // })
            // .then(()=>{
            //     console.log('hello');
            // })
            // .then(()=>{
            //     console.log('world')
            // })
            
            // console.log(Promise.resolve )
            // new Promise((resolve, reject)=>{
            //     setTimeout(()=>{
            //         resolve();
            //     },2000)
            // })
            // .then(()=>{
            //     console.log('a');
            //     return 'hello';
            //     return new Promise((resolve, reject)=>{
            //         setTimeout(()=>{
            //             if ( resolve.hasDone ){
            //                 promiseArr.push({ next:1, go:2, goTo(), setSeek:false });
            //             }
            //         }, 4000)
            //     })
            // })
            // .then((res)=>{
            //     console.log(res);
            //     console.log('b');
            // })
            if ( this.$route.query.type ) {
                this.menuKey = this.$route.query.type;
            } else {
                this.fetchList();
                
            }
        }
    }
    
</script>
<style scoped>
    .custom-radio {
        border-radius:4px;
        padding:4px;
        display:inline-block;
        background:#fff;
    }
    .custom-radio .custom-radio-item {
        display:inline-block;
        padding:0 40px;
        height:40px;
        line-height:40px;
        border-radius:4px;
        color:#99A0AE;
        margin-right:6px;
        background:transparent;
        transition: all 0.5s;
        cursor: pointer;
    }
    .custom-radio .custom-radio-item:last-child {
        margin-right:0;
    }
    .custom-radio .custom-radio-item:hover {
        background:#fafafa;
    }
    .custom-radio .custom-radio-item.selected {
        background:#335CFF;
        color:#fff;
    }
    .list-container {
        margin-bottom:36px;
    }
    .list-title {
        font-size:16px;
        line-height:30px;
        color:#525866;
        margin-bottom:10px;
    }
    .list-content {
        
    }
    .list-content > div {
        display:flex;
        align-items: center;
        flex-wrap:wrap;
        gap:24px; 
    }
    .card, .card-2 {  
        width:calc( 25% - 18px);
        background:#fff;
        padding:32px;
        border-radius:4px;
        background-image:none;
        transition:all 0.3s;
       
    }

    .card:hover {
        background-image:url(../../assets/card-hover-bg.png);
    }
    .card-2:hover {
        box-shadow: 0px 2px 12px 2px rgb(57, 58, 63, 0.05);
    }
    .card-2 .card-2-avatar {
        height:200px;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size:contain;
        margin-bottom:14px;
    }
    .card-2 .card-2-title {
        font-size:16px;
        line-height:40px;
        color:#0A0D14;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .card-2 .card-2-text {
        font-size:14px;
        color:#777777;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .card .card-title {
        display:flex;
        align-items: center;
        font-size:18px;
        line-height:30px;
        color:#0A0D14;
    }
    .card .card-avatar {
        margin-right:16px;
        line-height:0;
    }
    .card .card-avatar > img {
        width:30px;
        height:30px;
    }
    .card .card-text {
        font-size:18px;
        color:#0A0D14;
        white-space: nowrap;      /* 确保文本在一行内显示 */
        overflow: hidden;         /* 隐藏溢出的内容 */
        text-overflow: ellipsis;  /* 使用省略号表示文本溢出 */ 
    }
    .card .card-content {
        margin:14px 0;
        height:40px;
        line-height:20px;
        padding:0;
        color:#777777;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 显示3行 */
        overflow: hidden;
        text-overflow: ellipsis; /* 多行时显示省略号 */
        white-space:normal;
    }
    .card .card-footer > .tag {
        display:inline-block;
        border-radius:4px;
        border:1px solid #99A0AE;
        font-size:12px;
        line-height:18px;
        padding:2px 8px;
        color:#99A0AE;
        background-color:#fff;
    }
</style>